'use strict';

/**
 * Инциализация swiper
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

let presets = {
	'default': {
		loop: true,
		pagination: {
			el: '.js-default-slider-pagination',
			type: 'bullets',
			clickable: true,
			bulletClass: 'default-slider__bullet',
			bulletActiveClass: 'default-slider__bullet--active'
		},
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		},
		on: {
			slideChange: function () {
				window.lazyLoad.observe();
			}
		}
	},
	review: {
		loop: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		autoHeight: true,
		preloadImages: false,
		lazy: {
			loadPrevNext: true
		},
		pagination: false,
		simulateTouch: false,
		allowSwipeToNext: false,
		allowSwipeToPrev: false,
		on: {
			lazyImageLoad: function () {
				this.update();
			}
		}
	},
	'review-image': {
		loop: true,
		lazy: {
			loadPrevNext: true
		},
		pagination: {
			el: '.js-default-slider-pagination',
			type: 'bullets',
			bulletClass: 'default-slider__bullet',
			bulletActiveClass: 'default-slider__bullet--active',
			clickable: true
		},
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		},
		on: {
			slideChange: function () {
				if (window.Gapi['review']) {
					window.Gapi['review'].slideTo(this.activeIndex);
				}
			}
		}
	}
};

/**
 * @param {string} [selector]- поиск элементов по селектору
 * @sourceCode
 */
function swiper (selector) {
	window.Gapi = {};

	$(selector).each(function () {
		let $this = $(this);
		let preset = $this.data('preset') || 'default';
		window.Gapi[preset] = new window.Swiper(this, presets[preset]);// eslint-disable-line no-new
	});
}

(function ($) {
	$(window).on('load', function () {
		let $swiper = $('.js-swiper');
		let $slid = $swiper.find('.swiper-slide');
		if ($swiper.length) {
			if ($slid.length > 1) {
				require.ensure([], () => {
					window.Swiper = require('_vendors/swiper.js');
					require('_vendors/swiper.css');
					swiper('.js-swiper');
				}, 'swiper');
			} else if ($slid.length === 1) {
				$swiper.addClass('is-one');
				$slid.css('background-image', `url(${$slid.data('background')})`);
			}
		}
	});
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/swiper.js